export default __webpack_public_path__ + "static/Vladyslav  Makarian-e800864a5d43604377ce05b8301979e8.png";